import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseComponent } from "./base/base/base.component";
import { RandomGuardService } from "./guards/random-guard.service";

//import { DashboardChartsRoutingModule } from './dashboard-charts-routing.module';

const routes: Routes = [
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  // },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./pages/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    //  canActivate: [RandomGuardService],
    //  canLoad: [RandomGuardService]
  },
  {
    path: "hc-appointment-booking",
    loadChildren: () =>
      import(
        "./book-appointment/book-health-check/book-health-check.module"
      ).then((m) => m.BookHealthCheckModule),
  },
  {
    path: "base",
    component: BaseComponent,
    // canActivate: [RandomGuardService],
    // canLoad: [RandomGuardService],
    children: [
      {
        path: "custom-message",
        loadChildren: () =>
          import("./custom-messages/custom-messages.module").then(
            (m) => m.CustomMessagesModule
          ),
      },
      {
        path: "dashboards-charts",
        loadChildren: () =>
          import("./dashboard-charts/dashboard-charts.module").then(
            (m) => m.DashboardChartsModule
          ),
        // canActivate: [RandomGuardService],
        //  canLoad: [RandomGuardService]
      },

      {
        path: "reports",
        loadChildren: () =>
          import("./crm-reports/crm-reports.module").then(
            (m) => m.CrmReportsModule
          ),
      },
      {
        path: "task-schedulers",
        loadChildren: () =>
          import("./task-schedulers/task-schedulers.module").then(
            (m) => m.TaskSchedulersModule
          ),
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule
          ),
        //  canActivate: [RandomGuardService],
        //  canLoad: [RandomGuardService]
      },
      {
        path: "admin-config",
        loadChildren: () =>
          import("./admin-config/admin-config.module").then(
            (m) => m.AdminConfigModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "manage-user",
        loadChildren: () =>
          import("./get-users/get-users.module").then((m) => m.GetUsersModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "role-based",
        loadChildren: () =>
          import("./role-Based/role-Based.module").then(
            (m) => m.RoleBasedModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "role-based-feature",
        loadChildren: () =>
          import("./role-based-feature/role-based-feature.module").then(
            (m) => m.RoleBasedFeatureModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "role-based-actions",
        loadChildren: () =>
          import("./role-based-actions/role-based-actions.module").then(
            (m) => m.RoleBasedActionsModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "lead-refresh",
        loadChildren: () =>
          import(
            "./pages/dashboard/lead-refresh-timeout/lead-refresh-timeout.module"
          ).then((m) => m.LeadRefreshTimeoutModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "user-based-role",
        loadChildren: () =>
          import("./user-based-roles/user-based-roles.module").then(
            (m) => m.UserBasedRolesModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "contacts",
        loadChildren: () =>
          import("./contacts/contacts.module").then((m) => m.ContactsModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "leads",
        loadChildren: () =>
          import("./leads/leads.module").then((m) => m.LeadsModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "call-center",
        loadChildren: () =>
          import("./call-center/call-center.module").then(
            (m) => m.CallCenterModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "contact-groups",
        loadChildren: () =>
          import("./contact-groups/contact-groups.module").then(
            (m) => m.ContactGroupsModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "activities",
        loadChildren: () =>
          import("./activities/activities.module").then(
            (m) => m.ActivitiesModule
          ),
        //  canActivate: [RandomGuardService],
        //  canLoad: [RandomGuardService]
      },
      {
        path: "activity-lead",
        loadChildren: () =>
          import("./activity-lead/activity-lead.module").then(
            (m) => m.ActivityLeadModule
          ),
      },
      {
        path: "campaigns",
        loadChildren: () =>
          import("./campaign/campaign.module").then((m) => m.CampaignModule),
      },
      {
        path: "forms",
        loadChildren: () =>
          import("./pages/sample-form/sample-form.module").then(
            (m) => m.SampleFormModule
          ),
      },
      {
        path: "tables",
        loadChildren: () =>
          import("./pages/sample-table/sample-table.module").then(
            (m) => m.SampleTableModule
          ),
        //loadChildren: () => import('./activities/activities.module').then(m => m.ActivitiesModule)
      },
      {
        path: "caremanager",
        loadChildren: () =>
          import("./care-manager/care-manager.module").then(
            (m) => m.CareManagerModule
          ),
      },
      {
        path: "Dashboards",
        loadChildren: () =>
          import("./Dashboards/dashboards/dashboards.module").then(
            (m) => m.DashboardsModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "centremanager/centre-manager-dashboard",
        loadChildren: () =>
          import(
            "./centre-manager/centre-manager-dashboard/centre-manager-dashboard.module"
          ).then((m) => m.CentreManagerDashboardModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "centremanager/manage-package-leads",
        loadChildren: () =>
          import(
            "./centre-manager/manage-package-leads/manage-package-leads.module"
          ).then((m) => m.ManagePackageLeadsModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "settargets",
        loadChildren: () =>
          import("./set-targets/set-targets.module").then(
            (m) => m.SetTargetsModule
          ),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "targets/digital-mis",
        loadChildren: () =>
          import(
            "./digital-mis-target/crm-digital-mis/crm-digital-mis.module"
          ).then((m) => m.CrmDigitalMisModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "targets/digital-mis-target",
        loadChildren: () =>
          import(
            "./digital-mis-target/set-targets-to-digital-mis/set-targets-to-digital-mis.module"
          ).then((m) => m.SetTargetsDigitalMISModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: "targets/digital-mis-form",
        loadChildren: () =>
          import(
            "./digital-mis-target/digital-mis-form/digital-mis-form.module"
          ).then((m) => m.DigitalMISFormModule),
        canActivate: [RandomGuardService],
        canLoad: [RandomGuardService],
      },
      {
        path: " ",
        redirectTo: "auth/login",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "",
    redirectTo: "auth/login",
    pathMatch: "full",
  },
  // {
  //   path: '**',
  //   redirectTo:'auth/login'
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
